import React, { useState, useEffect } from "react";
import profileImage from "../../../assets/images/profile.png";
import { useNavigate, Navigate, Link } from "react-router-dom";
// @ts-ignore

import {
    Button,
    Popover,
    OverlayTrigger,
    Accordion,
    Tooltip,
    Dropdown

} from "react-bootstrap";
// @ts-ignore
import { logOut } from "../../../redux/Admin/actions/adminAuthActions/authAction";
import { useSelector, useDispatch } from "react-redux";
import CommonModal from "../../Common/CommonModal";
import { logOutMessage } from "../../../constants/constatntMessages";
import io from "socket.io-client";
import { openSidebar } from "../../../redux/actions/commonActions/commonAction";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Typography,
    TextField,
    InputAdornment,
    Grid,
} from "@mui/material";




function AdminHeader() {


    useEffect(() => {
        document.title = "Employee: MinutesVault";

        if (!accessToken) {
            navigate("/admin-login-by-password");
        }

       
        
    }, []);
    const socket = io.connect("http://192.168.1.5:8080", {
        transports: ["websocket"],
    });
    const userData = JSON.parse(localStorage.getItem("userData"));
    const accessToken = localStorage.getItem("accessToken");



    const [isModalOpen, setIsModalOpen] = useState(false);
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [isToolTipOpen, setIsToolTipOpen] = useState(true);

    const [profilePicture, setProfilePicture] = useState("");

   const handleLogout = () => {
     localStorage.removeItem("accessToken");
     localStorage.removeItem("userData");
     localStorage.removeItem("rememberMe");
     dispatch(logOut());
     setIsModalOpen(false);
     navigate("/admin-login");
   };

    const tooltip = (attendee) => {
        return (
            <Tooltip id="tooltip">
                {attendee.name} / {attendee?.email}
            </Tooltip>
        );
    };
    return (
        <>
            <section className="topbar">
                <div className="topbar-1" onMouseEnter={() => {
                    setIsToolTipOpen(true)
                }}>
                    <div className="topbar1-content">
                        <div className="d-flex align-items-center">
                            <button
                                className="ps-0 sidebar-open-btn "
                                onClick={() => dispatch(openSidebar())}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    fill="#000"
                                    className="bi bi-list"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
                                    />
                                </svg>
                            </button>
                            <div className="meeting">MinutesVault</div>
                        </div>

                        <div className="top-right-svg headerpprofile">
                            <Link
                            // to={
                            //     notificationData?.notificationList?.length !== 0
                            //         ? `/notification`
                            //         : ""
                            // }
                            >
                                {/* <div className="bell">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="22"
                                        fill="#000"
                                        className="bi bi-bell "
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
                                    </svg>

                                </div> */}
                            </Link>
                            <div className="line"></div>

                            <Dropdown
                                onToggle={() => {
                                    setIsToolTipOpen(false);
                                }}
                            >
                                <Dropdown.Toggle>
                                    <div
                                        className="d-flex admin-box"
                                        title={`${userData?.name} / ${userData?.email}`}
                                    >
                                        <img
                                            src={profilePicture || profileImage}
                                            alt="Profile"
                                            className="user"
                                        />

                                        <span>
                                            Hi,{" "}
                                            <span>{userData.name}</span>
                                        </span>

                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-chevron-down"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                            />
                                        </svg>
                                    </div>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Link
                                        to="#"
                                        style={{ textDecoration: "none", color: "black" }}
                                    >
                                        <Dropdown.Item
                                            eventKey="4"
                                            onClick={() => {
                                                setIsModalOpen(true);
                                            }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="19"
                                                height="19"
                                                fill="currentColor"
                                                className="bi bi-box-arrow-left me-2"
                                                viewBox="0 0 16 16"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0z"
                                                />
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708z"
                                                />
                                            </svg>
                                            Logout
                                        </Dropdown.Item>
                                    </Link>
                                </Dropdown.Menu>
                            </Dropdown>

                        </div>
                    </div>
                </div>
                <CommonModal
                    message={logOutMessage}
                    title={"Logout"}
                    setIsModalOpen={setIsModalOpen}
                    isModalOpen={isModalOpen}
                    handleSubmit={handleLogout}
                    buttonName={"Logout"}
                />

            </section>
        </>
    );
};

export default AdminHeader